export const orphanedFiles = {
  connections: 'Existing connections',
  missing: 'Missing',
  linked: 'Linked',
  viewInPinList: 'Show in pin list',
  viewInPinListHint: 'Open this item in the project pin list',
  unassignedInProject: 'Unassigned in this project — opens the unassigned recordings drawer',
  albumMismatchTab: 'Album mismatches',
  albumMismatchCount: '{{count}} album mismatches found',
  albumMismatchHint:
    'Live pins and recordings whose album or project links disagree. The app collects by the pin album; the admin list uses pinKey. Repair aligns them without deleting anything.',
  repairSelected: 'Repair selected ({{count}})',
  repairSuccess: 'Repaired {{count}} mismatch(es)',
  repairFailed: 'Failed to repair album mismatches',
  mismatchReasons: 'Why this is a mismatch:',
  recentlyRepaired: 'Recently repaired',
  recentlyRepairedHint: 'These recordings were aligned to the pin album and project. They stay here so you can confirm what changed.',
  recentlyRepairedCount: '{{count}} recently repaired',
  repairedBadge: 'Repaired',
  none: '(none)',
  repairChangeAlbum: 'Album: {{from}} → {{to}}',
  repairChangeProject: 'Project: {{from}} → {{to}}',
  repairChangePin: 'Pin: {{from}} → {{to}}',
  repairChangePinAlbum: 'Pin album set to {{to}}',
  repairChangeWanderAlbum: 'Wander album set to {{to}}',
  kinds: {
    project: 'Project',
    pin: 'Pin',
    album: 'Album',
    recording: 'Recording',
    wander: 'Wander',
    episode: 'Episode list',
  },
}
